import { useDispatch } from 'react-redux';
import { Thunk } from '../types/reduxTypes';

// Applies the correct typing to the useDispatch hook so that it can be used to dispatch thunks
// Using the standard useDispatch gives an incorrect return type of Thunk<R> instead of R, which causes issues when we want to return values from thunks
const useThunkDispatch = () => useDispatch<<R>(thunk: Thunk<R>) => R>();

export default useThunkDispatch;
